<script setup lang="ts">
import { GeneralChartTimeSetup } from '@/composables/charts/influx-charts/chart-serialization/ChartTimeSetup'
import { ANNOTATOR_TYPES } from '@/composables/charts/influx-charts/ChartIncidentAnnotators'
import GenericInfluxChart from '@/composables/charts/GenericInfluxChart.vue'
import { InfluxLineChartBuilder } from '@/composables/charts/influx-charts/chart-builders/InfluxLineChartBuilder'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
withDefaults(
  defineProps<{
    synchronizationKey?: string
    fixedTimeResolution?: number
    days?: number
  }>(),
  {
    fixedTimeResolution: undefined,
    days: 7,
    synchronizationKey: undefined,
  }
)
</script>

<template>
  <GenericInfluxChart
    :chart-builder="
      new InfluxLineChartBuilder({
        chartType: CHART_TYPES.LINE,
        measurement: 'activity',
        field: 'activity',
        xAggregation: 'mean',
        timeSetup: GeneralChartTimeSetup.lastNDays(days, synchronizationKey, fixedTimeResolution).serialize(),
        title: $t('charts.titles.activity'),
        subtitle: $t('charts.subtitles.activityGlobal'),
        incidentAnnotators: [{ annotatorType: ANNOTATOR_TYPES.BARNDOC }, { annotatorType: ANNOTATOR_TYPES.SPARSE_DICT_ANOMALY }],
        incidentReducer: { reducerType: 'penState' },
      })
    "
  ></GenericInfluxChart>
</template>

<style scoped></style>
